
import { Options, Vue } from 'vue-class-component';
import { ActivityDataRecorderClient, CompanyClient, TravelLogisticMobilityClient} from '@/services/Services';
import ActivityDataResultModal from '../modals/activityDataResultModal.vue';
import AddNewPremisesModal from '../modals/addNewPremisesModal.vue';
import InfoModal from '@/components/modals/infoModal.vue';
import * as OM from '@/Model';
import * as VM from '@/viewModel';

@Options({
    components: { },
})
export default class TravelLogisticMobilityActivityRecorder extends Vue {

    viewModel = VM;

    //globals
    timeFrameList: string[] = [];
    monthList: OM.TextIdentifier[] = [];
    categories: string[] = [];
    premises: OM.TextIdentifier[] = [];
    rndUoms: number = Math.random();

    destinations: string[] = [];
    referencesFlow1: string[] = [];
    transportModes: string[] = [];
    referencesFlow2: string[] = [];
    geographies: string[] = [];
    uoms: string[] = [];

    timeFrameSelected: string = "";
    travelLogisticMobilityEmissionData: OM.TravelLogisticMobilityEmissionData = new OM.TravelLogisticMobilityEmissionData();
    saveModel: OM.ActivityDataRecorderTravelLogisticMobilityVM = new OM.ActivityDataRecorderTravelLogisticMobilityVM();
    loaded: boolean = false;

    created() {
        this.init();
    }

    init() {
        this.timeFrameList = Object.values(VM.TimeFrame);
        this.timeFrameSelected = VM.TimeFrame.Year;

        var monthKeys = Object.keys(VM.Months);
        for(var i = 0; i < monthKeys.length; i++) {
            this.monthList.push({
                identifier: i.toString(),
                text: monthKeys[i]
            })
        }

        Promise.all([
            TravelLogisticMobilityClient.getCategories(),
            TravelLogisticMobilityClient.getDestinations(),
            TravelLogisticMobilityClient.getReferencesFlow1(),
            CompanyClient.getPremisesTextIDByCompany(),
        ])
        .then(xs => {
            this.categories = xs[0];
            this.destinations = xs[1];
            this.referencesFlow1 = xs[2];
            this.premises = xs[3];

            this.travelLogisticMobilityEmissionData.scope = VM.ScopesActivityRecorder.TravelLogisticMobility;

            this.loaded = true;
        })
    }

    addPremises() {
        this.$opModal.show(AddNewPremisesModal, {
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
        })
    }

    // categoryUpdated() {
    //     TravelLogisticMobilityClient.getReferencesFlow1(this.travelLogisticMobilityEmissionData.category)
    //     .then(x => {
    //         this.referencesFlow1 = x;
    //         this.travelLogisticMobilityEmissionData.referenceFlow1 = "";
    //         this.travelLogisticMobilityEmissionData.transportMode = "";
    //         this.travelLogisticMobilityEmissionData.referenceFlow2 = "";
    //         this.travelLogisticMobilityEmissionData.geography = "";
    //         this.travelLogisticMobilityEmissionData.uom = "";
    //         this.saveModel.consumptionSecondValue = null;
    //     })
    // }

    referenceFlow1Updated() {
        TravelLogisticMobilityClient.getTransportModes(this.travelLogisticMobilityEmissionData.referenceFlow1)
        .then(x => {
            this.transportModes = x;
            this.travelLogisticMobilityEmissionData.transportMode = "";
            this.travelLogisticMobilityEmissionData.referenceFlow2 = "";
            this.travelLogisticMobilityEmissionData.geography = "";
            this.travelLogisticMobilityEmissionData.uom = "";
            this.saveModel.consumptionSecondValue = null;
        })
    }

    transportModeUpdated() {
        TravelLogisticMobilityClient.getReferencesFlow2(this.travelLogisticMobilityEmissionData.referenceFlow1, this.travelLogisticMobilityEmissionData.transportMode)
        .then(x => {
            this.referencesFlow2 = x;
            this.travelLogisticMobilityEmissionData.referenceFlow2 = "";
            this.travelLogisticMobilityEmissionData.geography = "";
            this.travelLogisticMobilityEmissionData.uom = "";
            this.saveModel.consumptionSecondValue = null;
        })
    }

    referenceFlow2Updated() {
        TravelLogisticMobilityClient.getGeographies(this.travelLogisticMobilityEmissionData.referenceFlow1, this.travelLogisticMobilityEmissionData.transportMode, this.travelLogisticMobilityEmissionData.referenceFlow2)
        .then(x => {
            this.geographies = x;
            this.travelLogisticMobilityEmissionData.geography = "";
            this.travelLogisticMobilityEmissionData.uom = "";
            this.saveModel.consumptionSecondValue = null;
        })
    }

    geographyUpdated() {
        TravelLogisticMobilityClient.getUoms(this.travelLogisticMobilityEmissionData.referenceFlow1, this.travelLogisticMobilityEmissionData.transportMode, this.travelLogisticMobilityEmissionData.referenceFlow2, this.travelLogisticMobilityEmissionData.geography)
        .then(x => {
            this.uoms = x;
            this.rndUoms = Math.random();
            this.travelLogisticMobilityEmissionData.uom = "";
            this.saveModel.consumptionSecondValue = null;
        })
    }

    get hasSecondConsumptionValue() {
        if(!this.travelLogisticMobilityEmissionData.uom)
            return false;

        if(this.travelLogisticMobilityEmissionData.uom.indexOf("*") > -1)
            return true;
        else
            return false;
    }

    get firstConsumptionType() {
        if(!this.hasSecondConsumptionValue)
            return "";

        var dividerPos = this.travelLogisticMobilityEmissionData.uom.indexOf("*");
        var firstType = this.travelLogisticMobilityEmissionData.uom.substring(0, dividerPos);
        return " (" + firstType + ")";
    }

    get secondConsumptionType() {
        if(!this.hasSecondConsumptionValue)
            return "";

        var dividerPos = this.travelLogisticMobilityEmissionData.uom.indexOf("*");
        var secondType = this.travelLogisticMobilityEmissionData.uom.substring((dividerPos + 1));
        return " (" + secondType + ")";
    }

    get calculateDisabled() {
        var baseCheck = !this.travelLogisticMobilityEmissionData.destination || !this.saveModel.selectedPremises.identifier ||
            !this.saveModel.year || !this.saveModel.consumption || !this.travelLogisticMobilityEmissionData.referenceFlow1 ||
            !this.travelLogisticMobilityEmissionData.transportMode || !this.travelLogisticMobilityEmissionData.referenceFlow2 || !this.travelLogisticMobilityEmissionData.geography || !this.travelLogisticMobilityEmissionData.uom;

        if(this.timeFrameSelected == VM.TimeFrame.Month)
            baseCheck = baseCheck || !this.saveModel.month;

        if(this.hasSecondConsumptionValue)
            baseCheck = baseCheck || !this.saveModel.consumptionSecondValue;

        return baseCheck;
    }

    calculateAndSave() {
        this.saveModel.emissionDataBase = this.travelLogisticMobilityEmissionData;
        this.saveModel.selectedPremises = this.premises.find(x => x.identifier == this.saveModel.selectedPremises.identifier);

        TravelLogisticMobilityClient.getEF(this.travelLogisticMobilityEmissionData.referenceFlow1, this.travelLogisticMobilityEmissionData.transportMode, this.travelLogisticMobilityEmissionData.referenceFlow2, this.travelLogisticMobilityEmissionData.geography, this.travelLogisticMobilityEmissionData.uom)
        .then(x => {
            this.assingEFValueAndSave(x);
        })
    }

    assingEFValueAndSave(ef: number) {
        this.saveModel.emissionDataBase.ef = ef;

        if(this.timeFrameSelected == VM.TimeFrame.Year)
            this.saveModel.month = -1;

        ActivityDataRecorderClient.checkIfTravelLogisticMobilityRecodAlreadyExist(this.saveModel)
        .then(x => {
            if(!x)
                this.saveScope3();
            else {
                this.$opModal.show(InfoModal, {
                    text: this.$localizationService.getLocalizedValue("Attention", "Attention"),
                    subtitle: this.$localizationService.getLocalizedValue(x, x),
                    confirm: this.$localizationService.getLocalizedValue("Proceed", "Proceed"),
                    confirmCb: () => {
                        this.$opModal.closeLast();
                        this.saveScope3();
                    },
                    deny: this.$localizationService.getLocalizedValue("Avoid", "Avoid"),
                    denyCb: () => {
                        this.$opModal.closeLast();
                    }
                })
            }
        })
    }

    saveScope3() {
        ActivityDataRecorderClient.saveTravelLogisticMobility(this.saveModel)
        .then(() => {
            var risValue = this.saveModel.emissionDataBase.ef * this.saveModel.consumption;
            if(this.saveModel.consumptionSecondValue)
                risValue = risValue * this.saveModel.consumptionSecondValue;

            this.$opModal.show(ActivityDataResultModal, {
                emissionValue: risValue
            })
        })
    }

}
